import { useSelector } from 'react-redux';

import { RootState } from 'store/index';

import { UserEventType } from 'types/core/userTypes';

export const useActiveEvent = (): UserEventType | null | undefined => {
  const activeEvent = useSelector((state: RootState) => state.eventsSlice.activeUserEvent);
  return activeEvent;
};
